// Mirrors DEFAULT_THROTTLE_RATES["dentally_availability"] in the backend's
// config/settings.py. The two MUST move together: this paces the UI so it does
// not spend the allowance faster than the server grants it, so leaving this at
// 4 while the server allowed 20 would have kept the old pauses and made the
// server-side raise look like it had done nothing.
//
// Raised 4 -> 20 on 2026-10-05. The allowance is per PRACTICE and shared by
// everyone working in it, and four lookups a minute ran out while one person
// compared practitioners and dates.
export const RATE_LIMIT_REQUESTS = 20;
const RATE_LIMIT_WINDOW_MS = 60 * 1000;

const attemptsByPractice = new Map();

export function reserveDentallyAvailabilityRateSlot(practiceId, now = Date.now()) {
  const key = String(practiceId);
  const cutoff = now - RATE_LIMIT_WINDOW_MS;
  const recent = (attemptsByPractice.get(key) || []).filter((sentAt) => sentAt > cutoff);

  if (recent.length >= RATE_LIMIT_REQUESTS) {
    attemptsByPractice.set(key, recent);
    return {
      reserved: false,
      waitMs: Math.max(0, recent[0] + RATE_LIMIT_WINDOW_MS - now),
    };
  }

  recent.push(now);
  attemptsByPractice.set(key, recent);
  return { reserved: true, waitMs: 0 };
}

export function __resetDentallyAvailabilityRateBudgetForTests() {
  attemptsByPractice.clear();
}
